import CPoint from '../../cppComponents/CPoint';
import Domino from './CDomino';
import React from 'react';
import { View } from 'react-native';

class CDomino3 extends Domino {
    async OnLButtonDown(point: CPoint) {
        console.log('point', point);
    }
    async OnRButtonDown(point: CPoint) {
        console.log('point', point);
    }
    async ReceiveGame(strRecvd: string) {
        console.log(strRecvd);
        return true;
    }
    Timer7() {}
    Timer3() {}
    constructor(props) {
        super(props);
    }
    Timer1() {}

    DrawView() {
        return null;
    }

    render() {
        if (this.props.m_pwin.game === 'Domino3') {
            return <View key={'Domin3'}>{this.DrawView()}</View>;
        } else {
            return null;
        }
    }
}

export default CDomino3;
